import axios from '@plugins/axios';

class ReporteDetalladaService {
    get(params = {}, options = {}) {
        if (Object.hasOwnProperty.call(params, 'compare')) {
            params['compare'] = params['compare'] ? 1 : 0;         
        }

        if (Object.hasOwnProperty.call(params, 'consolidado')) {
            params['consolidado'] = params['consolidado'] ? 1 : 0;         
        }

        if (Object.hasOwnProperty.call(params, 'force_comercio_grouping')) {
            params['force_comercio_grouping'] = params['force_comercio_grouping'] ? 1 : 0;         
        }

        return axios({
            url: `reporte/venta/detallada`,
            method: 'GET',
            params,
            ...options
        });
    }
}

export const BaseReporteDetalladaService = ReporteDetalladaService

export default new ReporteDetalladaService();